import React from 'react';
import './styles/about_us.css';

const AboutUs: React.FC = () => {
  return (
    <div className="about-us-page">
      <div className="about-us-content">
        <section className="about-section">
          <h1>About Us</h1>
          <p>
            At Qulaka OÜ, our mission is to empower businesses to make informed decisions and 
            achieve sustainable growth through innovative data science and analytics solutions. 
            We are dedicated to transforming raw data into actionable insights, enabling organizations 
            to better understand their operations, customers, and markets. By harnessing the power of 
            advanced technologies and customized methodologies, we ensure that our clients unlock the 
            full potential of their data, fostering efficiency, accuracy, and strategic advantage.
          </p>
        </section>
        <section className="mission-section">
          <h2>Our Mission</h2>
          <p>
            As a trusted data consultancy partner, we specialize in guiding businesses through every step 
            of their data journey, from collection and processing to advanced visualization and predictive 
            modeling. Our primary goal is to help our clients analyze their data more effectively, providing 
            tailored recommendations to optimize processes, uncover opportunities, and improve overall 
            performance. At Qulaka OÜ, we are committed to delivering results-driven solutions that empower 
            businesses to thrive in today’s dynamic, data-driven world.
          </p>
        </section>
      </div>
    </div>
  );
};


export default AboutUs;